import { ZENDESK_ARTICLE_BASE_URL } from 'shared/hooks/useZendesk';
import { integrationSystemDisplayName, IntegrationSystemDisplayNameType } from 'shared/providers/IntegrationsProvider';

export const getZendeskLink = (integration: IntegrationSystemDisplayNameType, employeeSection?: boolean): string => {
  let link = '';
  if (integration === integrationSystemDisplayName.AVIMARK) {
    link = employeeSection
      ? `${ZENDESK_ARTICLE_BASE_URL}/12473453813645-Configuring-Payment-Write-Backs-for-AVImark#h_01GRW9T2BW3CPV28M4A1B533A8`
      : `${ZENDESK_ARTICLE_BASE_URL}/12473453813645-Configuring-Payment-Write-Backs-for-AVImark`;
  } else if (integration === integrationSystemDisplayName.CORNERSTONE) {
    link = employeeSection
      ? `${ZENDESK_ARTICLE_BASE_URL}/12475167538957-Configuring-Payment-Write-Backs-for-Cornerstone#h_01GRXQESRYQDRAHD55AY70WWSC`
      : `${ZENDESK_ARTICLE_BASE_URL}/12475167538957-Configuring-Payment-Write-Backs-for-Cornerstone`;
  } else if (integration === integrationSystemDisplayName.IMPROMED) {
    link = employeeSection
      ? `${ZENDESK_ARTICLE_BASE_URL}/12463006251917-Configuring-Payment-Write-Backs-for-Impromed#h_01GRYHG421Z40FYD7074CQHMGJ`
      : `${ZENDESK_ARTICLE_BASE_URL}/12463006251917-Configuring-Payment-Write-Backs-for-Impromed`;
  }

  return link;
};
